// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const updateTimesheetProposalStatusPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.coerce.string().describe("Proposal ID (uuid)"),
});

export const updateTimesheetProposalStatusHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Status updated successfully
 */
export const updateTimesheetProposalStatus200Schema = z.object({
  proposal: z.object({
    id: z.coerce.string(),
    date: z.string().date(),
    user_id: z.optional(z.number().int()),
    status: z.enum(["pending", "accepted", "rejected", "edited"]),
    log: z.optional(z.array(z.object({}))),
    metadata: z.optional(z.object({})),
    created_at: z.optional(z.coerce.string()),
    updated_at: z.coerce.string().nullish(),
    entries: z.optional(z.array(z.object({
      id: z.number().int(),
      timesheet_proposal_id: z.coerce.string(),
      date: z.string().date(),
      timely_project_id: z.number().int().nullish(),
      timely_label_ids: z.optional(z.array(z.number().int())),
      started_at: z.coerce.string().nullish(),
      ended_at: z.coerce.string().nullish(),
      hour_id: z.number().int().nullish(),
      note: z.coerce.string().nullish(),
      duration_minutes: z.number().int().nullish(),
      resource_id: z.coerce.string().describe("The work item this entry proposes: either a TIC resource uuid or a native linked work item uri (\"timely://work-items/<id>\").").nullish(),
      metadata: z.optional(z.object({})),
      created_at: z.optional(z.coerce.string()),
      updated_at: z.coerce.string().nullish(),
    }))),
    items: z.optional(z.array(z.object({
      id: z.number().int(),
      timesheet_proposal_id: z.coerce.string(),
      timesheet_proposal_entry_id: z.number().int().nullish(),
      started_at: z.coerce.string().nullish(),
      ended_at: z.coerce.string().nullish(),
      note: z.coerce.string().nullish(),
      metadata: z.optional(z.object({})),
      created_at: z.optional(z.coerce.string()),
      updated_at: z.coerce.string().nullish(),
    }))),
  }),
});

/**
 * @description Proposal not found
 */
export const updateTimesheetProposalStatus404Schema = z.object({
  message: z.coerce.string(),
});

export const updateTimesheetProposalStatusMutationRequestSchema = z.object({
  status: z.enum(["pending", "accepted", "rejected", "edited"]),
  log_entry: z.optional(z.object({})),
});

export const updateTimesheetProposalStatusMutationResponseSchema = z.lazy(() => updateTimesheetProposalStatus200Schema);
